(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cw-faq-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFAQ(section) {
      const items = section.querySelectorAll('.faq-section__item');

      items.forEach(function (item) {
        const btn = item.querySelector('.faq-section__question');
        const answer = item.querySelector('.faq-section__answer');

        if (!btn || !answer) return;

        if (item.classList.contains('faq-section__item--open')) {
          item.setAttribute('data-open', '');
        }

        btn.addEventListener('click', function () {
          const isOpen = item.hasAttribute('data-open');

          if (isOpen) {
            close(item, btn, answer);
          } else {
            open(item, btn, answer);
          }
        });
      });

      function open(item, btn, answer) {
        item.classList.add('faq-section__item--open');
        item.setAttribute('data-open', '');
        btn.setAttribute('aria-expanded', 'true');
        answer.removeAttribute('hidden');
      }

      function close(item, btn, answer) {
        item.classList.remove('faq-section__item--open');
        item.removeAttribute('data-open');
        btn.setAttribute('aria-expanded', 'false');
        answer.setAttribute('hidden', '');
      }
    }

    document.querySelectorAll('.faq-section').forEach(initFAQ);

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) {
        const section = e.target.querySelector('.faq-section');
        if (section) initFAQ(section);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
